import { has } from "lodash";
import axios from "./_axios";

export const CrashReport = args => {
  let [label, data, severity] = args;
  if (!label || !data) {
    throw new Error(
      "Either label or data is empty. CrashReport needs both values."
    );
  }

  if (typeof data === "string") {
    data = {
      message: data,
      stack: ""
    };
  }

  let lsUser = localStorage.getItem("logged_user");
  let lsSelectedClient = localStorage.getItem("selectedClient");
  let lsActiveTab = localStorage.getItem("active_tab");

  if (lsUser) {
    try {
      lsUser = JSON.parse(lsUser);
    } catch (error) {}
  }

  const apiUrl = process.env.REACT_APP_API_URL;
  const postData = {
    label,
    app_user: lsUser,
    app_selected_client: lsSelectedClient,
    app_active_tab: lsActiveTab,
    app_api_url: apiUrl,
    severity,
    errorObject: data
  };

  if (has(data, "message")) {
    postData.errorMessage = data.message;
  }
  if (has(data, "stack")) {
    postData.stack = data.stack;
  }

  // Send the report to the Eisenlens crash server
  axios()
    .post(`/crash-reports`, JSON.stringify(postData))
    .then(console.info)
    .catch(console.info);
};

export default CrashReport;
